export default function(element, data, sendTrinityEvent) {
    // Only send landmark if element is visible
    if (isVisible(element)) {
        sendLandmark(data);
    }
}

// taken from jQuery code for :visible
// will trigger for visiblibity:hidden though (not sure if this is expected/wanted)
// same behaviour as in webshop though
function isVisible(element) {
    return !!( element.offsetWidth || element.offsetHeight || element.getClientRects().length );
}